/**
 * MUI Routes Configuration
 * This file contains all routes using the new MUI components
 * To switch from Reactstrap to MUI, import this file instead of index.js
 */

import { Navigate } from "react-router-dom"

// Profile - MUI version
import MuiUserProfile from "../pages/Authentication/MuiUserProfile"

// Authentication - MUI versions
import MuiLogin from "../pages/Authentication/MuiLogin"
import Logout from "../pages/Authentication/Logout"
import MuiRegister from "../pages/Authentication/MuiRegister"
import MuiForgetPassword from "../pages/Authentication/MuiForgetPassword"

// Dashboard - MUI version
import MuiDashboard from "../pages/Dashboard/MuiDashboard"

// Customers - MUI versions
import MuiCustomersList from "../pages/Customers/MuiCustomerList"
import MuiCustomerCreate from "../pages/Customers/MuiCustomerCreate"
import MuiCustomerDetail from "../pages/Customers/MuiCustomerDetail"

// Orders - MUI versions
import MuiOrdersList from "../pages/Orders/MuiOrdersList"
import MuiOrderCreate from "../pages/Orders/MuiOrderCreate"
import MuiOrderDetail from "../pages/Orders/MuiOrderDetail"
import invoicesDetail from "../pages/Orders/invoices-detail"
import MuiShipping from "pages/Orders/MuiShipping"
import ProductionOverview from "pages/Orders/productionOverview"
import MuiQuickView from "pages/Orders/MuiQuickView"

// Products - MUI versions
import MuiProductsList from "../pages/Products/MuiProductsList"
import MuiProductCreate from "../pages/Products/MuiProductCreate"
import MuiProductOverview from "../pages/Products/MuiProductOverview"
import MuiProductUpdate from "../pages/Products/MuiProductUpdate"
import VisualEditor from "../pages/Products/VisualEditor"

// Materials - MUI versions
import MuiMaterialsList from "../pages/Materials/MuiMaterialsList"
import MuiMaterialCreate from "../pages/Materials/MuiMaterialCreate"
import MuiMaterialOverview from "../pages/Materials/MuiMaterialOverview"

// Invoices - MUI versions
import MuiInvoicesList from "../pages/Invoices/MuiInvoicesList"
import MuiInvoiceCreate from "../pages/Invoices/MuiInvoiceCreate"
import MuiInvoiceDetail from "../pages/Invoices/MuiInvoiceDetail"

// Providers - MUI versions
import MuiProvidersList from "../pages/providers/MuiProvidersList"
import MuiProviderCreate from "../pages/providers/MuiProviderCreate"
import MuiProviderDetail from "../pages/providers/MuiProviderDetail"

// Payments - MUI versions
import MuiPaymentsList from "../pages/Payments/MuiPaymentsList"
import MuiPaymentCreate from "../pages/Payments/MuiPaymentCreate"
import MuiPaymentOverview from "../pages/Payments/MuiPaymentOverview"

// Tasks - MUI versions
import MuiTasksList from "../pages/Tasks/MuiTasksList"
import MuiTaskOverview from "../pages/Tasks/MuiTaskOverview"
import CreateTask from "../pages/Tasks/tasks-create"

// Loans - MUI versions
import MuiLoansList from "../pages/loans/MuiLoansList"

// Salespersons - MUI versions
import MuiSalespersonsList from "../pages/salespersons/MuiSalespersonsList"
import MuiSalespersonCreate from "../pages/salespersons/MuiSalespersonCreate"
import SalespersonDetail from "pages/salespersons/salesman_details"

// Cash Register - MUI version
import MuiCashRegister from "../pages/CashRegister/MuiCashRegister"

// Provider Dashboard - MUI version
import MuiProvidersDashboard from "../pages/Dashboard/MuiProvidersDashboard"

// Top Products & Materials - MUI versions
import MuiTopProducts from "../pages/Dashboard/MuiTopProducts"
import MuiTopMaterials from "../pages/Dashboard/MuiTopMaterials"
import MuiAnalyticsDashboard from "../pages/Dashboard/MuiAnalyticsDashboard"

// Economics - MUI version
import MuiEconomics from "../pages/Economics/MuiEconomics"

// Quote Reviews
import QuoteReviewPage from "pages/Orders/QuoteReviewPage"

// Other pages (keep existing until migrated)
import MuiSettingsConfiguration from "pages/Settings/MuiSettingsConfiguration"
import MuiSettingsBackup from "pages/Settings/MuiSettingsBackup"
import MuiSectionsSetup from "pages/Settings/MuiSectionsSetup"
import MuiSection from "../pages/Sections/MuiSection"
import MuiSectionsOverview from "../pages/Sections/MuiSectionsOverview"
import MuiSectionPage from "../pages/Sections/MuiSectionPage"
import PRESSA from "pages/Sections/PRESSA"
import ShipmentsPage from "pages/Shipping/shippingPage"
import MuiDriverPage from "pages/Shipping/MuiDriverPage"
import MuiStorePage from "pages/Store/MuiStorePage"
import StorePageV5 from "pages/Store/cpq/StorePageV5"
import MuiPackaging from "pages/packaging/MuiPackaging"
import MuiCloudLicences from "../pages/CloudLicences/MuiCloudLicences"
import MuiAboutPage from "../pages/About/MuiAboutPage"

const authProtectedRoutes = [
  // Dashboard
  { path: "/dashboard", component: MuiDashboard },
  { path: "/cashregister", component: MuiCashRegister },
  { path: "/dashboardproviders", component: MuiProvidersDashboard },
  { path: "/tasktypes", component: MuiSectionsSetup },
  { path: "/dashboardproducts", component: MuiTopProducts },
  { path: "/dashboardmaterials", component: MuiTopMaterials },
  { path: "/analytics", component: MuiAnalyticsDashboard },

  // Customers
  { path: "/customers", component: MuiCustomersList },
  { path: "/createcustomer", component: MuiCustomerCreate },
  { path: "/customer-detail/:id", component: MuiCustomerDetail },

  // Orders
  { path: "/orders", component: MuiOrdersList },
  { path: "/createorder", component: MuiOrderCreate },
  { path: "/order-detail/:id", component: MuiOrderDetail },
  { path: "/invoices-detail/:id", component: invoicesDetail },
  { path: "/shipping", component: MuiShipping },
  { path: "/quick-view", component: MuiQuickView },

  // Products
  { path: "/products", component: MuiProductsList },
  { path: "/createproduct", component: MuiProductCreate },
  { path: "/product-overview/:id", component: MuiProductOverview },
  { path: "/product-update/", component: MuiProductUpdate },

  // Materials
  { path: "/materials-list", component: MuiMaterialsList },
  { path: "/create-material/", component: MuiMaterialCreate },
  { path: "/material-overview/:id", component: MuiMaterialOverview },

  // Invoices
  { path: "/invoices/", component: MuiInvoicesList },
  { path: "/invoice-create", component: MuiInvoiceCreate },
  { path: "/invoice-detail/:id", component: MuiInvoiceDetail },

  // Providers
  { path: "/providers/", component: MuiProvidersList },
  { path: "/createprovider", component: MuiProviderCreate },
  { path: "/provider-detail/:id", component: MuiProviderDetail },

  // Payments
  { path: "/payments", component: MuiPaymentsList },
  { path: "/payments-list/", component: MuiPaymentsList },
  { path: "/createpayment", component: MuiPaymentCreate },
  { path: "/payment-edit/:id", component: MuiPaymentCreate },
  { path: "/payment-overview/:id", component: MuiPaymentOverview },

  // Tasks & Production
  { path: "/tasks", component: MuiTasksList },
  { path: "/CreateTask", component: CreateTask },
  { path: "/task-overview", component: MuiTaskOverview },

  // Loans
  { path: "/loans", component: MuiLoansList },

  // Salespersons
  { path: "/salespersons/", component: MuiSalespersonsList },
  { path: "/createsalesperson/", component: MuiSalespersonCreate },
  { path: "/salesperson-detail/:id", component: SalespersonDetail },

  // Other
  { path: "/economics", component: MuiEconomics },
  { path: "/section/", component: MuiSection },
  { path: "/settings-configuration", component: MuiSettingsConfiguration },
  { path: "/settings-backup", component: MuiSettingsBackup },
  { path: "/profile", component: MuiUserProfile },

  // Production pages (moved from SinglePageRoutes for consistent sidebar)
  { path: "/sections", component: MuiSectionsOverview },
  { path: "/operations", component: ProductionOverview },
  { path: "/packaging", component: MuiPackaging },

  // Quote Reviews
  { path: "/order-reviews", component: QuoteReviewPage },

  // Cloud Licences
  { path: "/cloud-licences", component: MuiCloudLicences },

  // About
  { path: "/about", component: MuiAboutPage },

  // Default redirect
  { path: "/", component: () => <Navigate to="/customers" replace /> },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: MuiLogin },
  { path: "/forgot-password", component: MuiForgetPassword },
  { path: "/register", component: MuiRegister },
]

const SinglePageRoutes = [
  { path: "/single/:section", component: MuiSectionPage },
  { path: "/driver/:driverId", component: MuiDriverPage },
  { path: "/store/:storeId", component: MuiStorePage },
  { path: "/quote", component: StorePageV5 },
  { path: "/visual-editor/:productId", component: VisualEditor },
]

export { publicRoutes, authProtectedRoutes, SinglePageRoutes }
